export const EXCLUSION_ENDPOINT = {
  GetExclusion: 'exclusions/Exclusions/{exclusionId}',
  CreateExclusion: 'exclusions/Exclusions',
  DeleteExclusion: 'exclusions/Exclusions/{exclusionId}',
  UpdateExclusion: 'exclusions/Exclusions/{exclusionId}',
  GetExclusionsByStudent:
    'exclusions/Exclusions/Schools/{schoolId}/Students/{studentId}',
  GetStudentExclusions: 'exclusions/Exclusions/Schools',
  CreateExclusionAppeal: 'exclusions/Exclusions/{exclusionId}/Appeals',
  DeleteExclusionAppeal:
    'exclusions/Exclusions/{exclusionId}/Appeals/{appealId}',
  UpdateExclusionAppeal:
    'exclusions/Exclusions/{exclusionId}/Appeals/{appealId}',
  CreateExclusionMeeting: 'exclusions/Exclusions/{exclusionId}/Meetings',
  UpdateExclusionMeeting:
    'exclusions/Exclusions/{exclusionId}/Meetings/{meetingId}',
  DeleteExclusionMeeting:
    'exclusions/Exclusions/{exclusionId}/Meetings/{meetingId}',
  GetExclusionMeetingAppeals:
    'exclusions/Exclusions/{exclusionId}/MeetingAppeals',
  CreateExclusionLinkedDocument:
    'exclusions/Exclusions/{exclusionId}/LinkedDocuments',
  DeleteExclusionLinkedDocument:
    'exclusions/Exclusions/{exclusionId}/LinkedDocuments/{linkedDocumentId}',
  UpdateExclusionLinkedDocument:
    'exclusions/Exclusions/{exclusionId}/LinkedDocuments/{linkedDocumentId}',
  GetExclusionLinkedDocuments:
    'exclusions/Exclusions/{exclusionId}/LinkedDocuments',
  UpdateExclusionReasons: 'exclusions/Exclusions/{exclusionId}/Reasons'
};
